import React from 'react';

const FilterCalender = ({
  width = '16',
  height = '16',
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      alt=""
      aria-hidden="true"
      {...rest}
    >
      <g clipPath="url(#clip0_2543_2526)">
        <path
          d="M3.4038 0C3.51519 0 3.62202 0.0442499 3.70079 0.123015C3.77955 0.20178 3.8238 0.308609 3.8238 0.42V1.2054H8.334V0.4254C8.334 0.314009 8.37825 0.20718 8.45702 0.128415C8.53578 0.0496499 8.64261 0.0054 8.754 0.0054C8.86539 0.0054 8.97222 0.0496499 9.05099 0.128415C9.12975 0.20718 9.174 0.314009 9.174 0.4254V1.2054H10.8C11.1182 1.2054 11.4233 1.33175 11.6483 1.55666C11.8733 1.78157 11.9998 2.08664 12 2.4048V10.8006C11.9998 11.1188 11.8733 11.4238 11.6483 11.6487C11.4233 11.8737 11.1182 12 10.8 12H1.2C0.881844 12 0.57671 11.8737 0.351684 11.6487C0.126658 11.4238 0.000159078 11.1188 0 10.8006L0 2.4048C0.000159078 2.08664 0.126658 1.78157 0.351684 1.55666C0.57671 1.33175 0.881844 1.2054 1.2 1.2054H2.9838V0.4194C2.98396 0.308113 3.02828 0.201439 3.10703 0.122803C3.18578 0.0441674 3.29251 -1.13558e-07 3.4038 0V0ZM0.84 4.6452V10.8006C0.84 10.8479 0.849312 10.8947 0.867403 10.9384C0.885495 10.982 0.912013 11.0217 0.945442 11.0552C0.978871 11.0886 1.01856 11.1151 1.06223 11.1332C1.10591 11.1513 1.15272 11.1606 1.2 11.1606H10.8C10.8473 11.1606 10.8941 11.1513 10.9378 11.1332C10.9814 11.1151 11.0211 11.0886 11.0546 11.0552C11.088 11.0217 11.1145 10.982 11.1326 10.9384C11.1507 10.8947 11.16 10.8479 11.16 10.8006V4.6536L0.84 4.6452ZM4.0002 8.7714V9.771H3V8.7714H4.0002ZM6.4998 8.7714V9.771H5.5002V8.7714H6.4998ZM9 8.7714V9.771H7.9998V8.7714H9ZM4.0002 6.3852V7.3848H3V6.3852H4.0002ZM6.4998 6.3852V7.3848H5.5002V6.3852H6.4998ZM9 6.3852V7.3848H7.9998V6.3852H9ZM2.9838 2.0448H1.2C1.15272 2.0448 1.10591 2.05411 1.06223 2.0722C1.01856 2.0903 0.978871 2.11681 0.945442 2.15024C0.912013 2.18367 0.885495 2.22336 0.867403 2.26703C0.849312 2.31071 0.84 2.35752 0.84 2.4048V3.8058L11.16 3.8142V2.4048C11.16 2.35752 11.1507 2.31071 11.1326 2.26703C11.1145 2.22336 11.088 2.18367 11.0546 2.15024C11.0211 2.11681 10.9814 2.0903 10.9378 2.0722C10.8941 2.05411 10.8473 2.0448 10.8 2.0448H9.174V2.6022C9.174 2.71359 9.12975 2.82042 9.05099 2.89919C8.97222 2.97795 8.86539 3.0222 8.754 3.0222C8.64261 3.0222 8.53578 2.97795 8.45702 2.89919C8.37825 2.82042 8.334 2.71359 8.334 2.6022V2.0448H3.8238V2.5968C3.8238 2.70819 3.77955 2.81502 3.70079 2.89378C3.62202 2.97255 3.51519 3.0168 3.4038 3.0168C3.29241 3.0168 3.18558 2.97255 3.10682 2.89378C3.02805 2.81502 2.9838 2.70819 2.9838 2.5968V2.0448Z"
          fill="#4A4A4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2543_2526">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { FilterCalender };
